import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private loadingCountSubject = new BehaviorSubject<number>(0);
    
    public loading$: Observable<boolean> = this.loadingSubject.asObservable();
    public loadingCount$: Observable<number> = this.loadingCountSubject.asObservable();

    private currentCount = 0;
    private loadingStartTime: number | null = null;
    private hideTimeout: any = null;
    private readonly MIN_DISPLAY_TIME = 1000; // 1 second minimum display time

    show(): void {
        this.currentCount++;
        this.loadingCountSubject.next(this.currentCount);
        
        if (!this.loadingSubject.value) {
            this.loadingStartTime = Date.now();
            this.loadingSubject.next(true);
            
            // Clear any pending hide timeout
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
            }
        }
    }

    hide(): void {
        if (this.currentCount > 0) {
            this.currentCount--;
        }
        
        this.loadingCountSubject.next(this.currentCount);
        
        if (this.currentCount === 0) {
            this.scheduleHide();
        }
    }

    private scheduleHide(): void {
        if (this.loadingStartTime) {
            const elapsedTime = Date.now() - this.loadingStartTime;
            const remainingTime = Math.max(0, this.MIN_DISPLAY_TIME - elapsedTime);
            
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
            }
            
            this.hideTimeout = setTimeout(() => {
                this.loadingSubject.next(false);
                this.loadingStartTime = null;
                this.hideTimeout = null;
            }, remainingTime);
        } else {
            this.loadingSubject.next(false);
        }
    }

    forceHide(): void {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
        
        this.currentCount = 0;
        this.loadingCountSubject.next(0);
        this.loadingSubject.next(false);
        this.loadingStartTime = null;
    }

    isLoading(): boolean {
        return this.loadingSubject.value;
    }

    getLoadingCount(): number {
        return this.currentCount;
    }
}